import { render, staticRenderFns } from "./addvehicle.vue?vue&type=template&id=f78739b0&scoped=true"
import script from "./addvehicle.js?vue&type=script&lang=js&external"
export * from "./addvehicle.js?vue&type=script&lang=js&external"
import style0 from "./addvehicle.vue?vue&type=style&index=0&id=f78739b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78739b0",
  null
  
)

export default component.exports